<div class="registration-card d-flex flex-column">
  <h3
    i18n="@@global.congratulation-exclamation-caps"
    [class.wallet-blue]="isCargoWallet"
  >
    CONGRATULATIONS!
  </h3>
  <img
    class="d-block ml-auto me-auto"
    src="/assets/animation/register-congratulation.gif"
    alt="register-congratulation-animation"
    width="170px"
    height="170px"
    loading="lazy"
  />
  <h6
    class="mb-3"
    i18n="@@registration.congratulation.text-account-registered"
    [class.wallet-black]="isCargoWallet"
  >
    Your account has been successfully registered and verified!
  </h6>
  <kt-registration-progress-bar
    [success]="true"
    class="mb-4"
    [isCargoWallet]="isCargoWallet"
  ></kt-registration-progress-bar>
  <button
    (click)="onNext.emit()"
    i18n="@@global.next-caps"
    [class.wallet-blue-bg]="isCargoWallet"
  >
    {{ isCargoWallet ? "OK" : "NEXT" }}
  </button>
  <div class="mt-4">
    <a href="/">
      <div
        class="signup-logo mt-4"
        [ngStyle]="{
          'background-image': 'url(' + backgroundImage + ')',
        }"
      ></div>
    </a>
  </div>
</div>
